export default "__VITE_ASSET__DCUw2Ozk__"